module.exports = __webpack_public_path__ + "static/media/funeral.d3be1d7c.jpg";